module.exports = __webpack_public_path__ + "img/masterpass-alternate.140f04a2.png";